<template>

<app-content-box :not-padded="true" :blank="true">

	<div class="days">
		
		<div class="days-item" v-for="(day, index) in days" :key="index">
			
			<div class="days-item-label">{{ day.text }}</div>

			<div class="days-item-content">

				<div class="days-item-content-roles">

					<div class="days-item-content-roles-empty" v-if="!day.roles.length">No roles scheduled.</div>

					<div class="days-item-content-role" v-for="role in day.roles" :key="role.role.id" v-tooltip="'Click to view details'" v-on:click="onRoleClick(day, role)" :class="{'is-red': progressWidth(role) === 0, 'is-green': progressWidth(role) === 100, 'is-yellow': progressWidth(role) > 0 && progressWidth(role) < 100}">

						<div class="days-item-content-role-label">{{ role.role.name }}</div>

						<div class="days-item-content-role-progress">
							<div class="days-item-content-role-progress-bar" :style="{width: progressWidth(role) + '%'}" />
						</div>

						<div class="days-item-content-role-percent">
							{{ progressWidth(role) }}%
						</div>

					</div>

				</div>

				<div class="days-item-content-metrics">
			
					<div class="days-item-content-metric">

						<div class="days-item-content-metric-label">Roles</div>

						<div class="days-item-content-metric-value">{{ day.summary.roles }}</div>

					</div>
				
					<div class="days-item-content-metric">

						<div class="days-item-content-metric-label">Slots</div>

						<div class="days-item-content-metric-value">{{ day.summary.slots }}</div>

					</div>
				
					<div class="days-item-content-metric">

						<div class="days-item-content-metric-label">Capacity</div>

						<div class="days-item-content-metric-value">{{ day.summary.capacity }}</div>

					</div>
				
					<div class="days-item-content-metric">

						<div class="days-item-content-metric-label">Filled</div>

						<div class="days-item-content-metric-value">{{ filledPercent(day) }}</div>

					</div>

				</div>
			
			</div>

		</div>

	</div>

</app-content-box>

</template>

<script>

export default {

	props: ['days'],

	methods: {

		onRoleClick: function(day, role) {

			return this.$router.push({
				name: 'Convention.Volunteers.Slots',
				params: {
					role: role.role.id
				},
				query: {
					day: day.key
				}
			})

		},
	
		filledPercent: function(day) {

			return (day.summary.capacity) ? Math.floor((100 / day.summary.capacity) * day.summary.filled).toString() + '%' : '0%'
		
		},
	
		progressWidth: function(role) {
		
			return (role.capacity) ? Math.floor((100 / role.capacity) * role.filled) : 0
		
		}
	
	}

}

</script>

<style scoped>

.days {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 10px;
	padding-bottom: 20px;
}

.days-item {
	display: grid;
	grid-template-rows: 40px auto;
	box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px;
	border-radius: 4px;
}

.days-item-label {
	border-top: 1px solid #eee;
	padding: 0px 10px;
    background-color: #fff;
	color: #fff;
	font-weight: 500;
	font-size: 16px;
	line-height: 36px;
    background-color: #4082d3;
	border-radius: 4px 4px 0px 0px;
}

.days-item-content {
	border: 1px solid #eee;
	border-top: 0px;
	background-color: #fff;
	border-radius: 0px 0px 4px 4px;
	display: grid;
	grid-template-rows: auto 36px;
}

.days-item-content-roles {
	min-height: 100px;
}

.days-item-content-roles-empty {
    font-size: 20px;
    color: #ccc;
    line-height: 24px;
    text-align: center;
    left: 0px;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 500;
}

.days-item-content-role {
	display: grid;
	align-items: center;
	grid-template-columns: 1fr 1fr 50px;
	border-top: 1px solid #eee;
	padding: 10px 10px;
	cursor: pointer;
}

.days-item-content-role:hover {
	background-color: #f7f7f7;
}

.days-item-content-role:first-child {
	border-top: 0px;
}

.days-item-content-role-label {
	color: #343434;
}

.days-item-content-role-progress {
	height: 12px;
	background-color: #eee;
	border-radius: 4px;
	width: 100%;
}

.days-item-content-role-progress-bar {
	background-color: #4082d3;
	border-radius: 4px;
	height: 12px;
	min-width: 4px!important;
	width: 0%;
}

.days-item-content-role.is-red .days-item-content-role-progress-bar {
	background-color: #c55b5b;
}

.days-item-content-role.is-yellow .days-item-content-role-progress-bar {
	background-color: #ffbe7a;
}

.days-item-content-role.is-green .days-item-content-role-progress-bar {
	background-color: #4faa80;
}

.days-item-content-role-percent {
	font-weight: 500;
	color: #4082d3;
	text-align: right;
}

.days-item-content-role.is-red .days-item-content-role-percent {
	color: #c55b5b;
}

.days-item-content-role.is-yellow .days-item-content-role-percent {
	color: #ffbe7a;
}

.days-item-content-role.is-green .days-item-content-role-percent {
	color: #4faa80;
}

.days-item-content-metrics {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	border-top: 1px solid #eee;
}

.days-item-content-metric {
	display: grid;
	grid-template-columns: auto auto;
	border-right: 1px solid #eee;
	padding: 10px 10px;
}

.days-item-content-metric:last-child {
	border-right: 0px;
}

.days-item-content-metric-label {
	color: #343434;
	line-height: 16px;
}

.days-item-content-metric-value {
	text-align: right;
	font-weight: 500;
	line-height: 14px;
	font-size: 16px;
	color: #343434;
}

</style>